import styled from 'styled-components'

const StEmptyCard = styled.div`
  ${({ theme }) => `
    background-color: ${theme.Components.Card.Fill};
    border: 1px solid ${theme.Components.Card.Border};
    padding: ${theme.UI.SpacingPx.Space4};
    border-radius: ${theme.UI.BorderRadius.Large}px;
  `}
`

export { StEmptyCard }
